module.exports = __webpack_public_path__ + "img/10.2b0225f0.png";